/**
 * @generated SignedSource<<74c99a5313c98c2cafc2c05eb0c70c57>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BusinessBoard_withWorkflow_query$data = {
  readonly jira_categoryField: {
    readonly fieldId: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_query" | "BoardContent_query" | "BoardFieldIdsProvider_query" | "IssueCreateProvider" | "IssueLinkingProvider">;
  readonly " $fragmentType": "BusinessBoard_withWorkflow_query";
};
export type BusinessBoard_withWorkflow_query$key = {
  readonly " $data"?: BusinessBoard_withWorkflow_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BusinessBoard_withWorkflow_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BusinessBoard_withWorkflow_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardFieldIdsProvider_query"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContent_query"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContentOld_query"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateProvider"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueLinkingProvider"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "jira_categoryField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "fieldId"
          },
          "action": "THROW",
          "path": "jira_categoryField.fieldId"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "9ae529b5c0520ce9c7792a1d78c52de9";

export default node;
